import React, { Fragment, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom'
import Common from '../../../Shared/Common';
import Block from '../../../Controls/Scafolding/Block';

import { Container, Row, Col, FormGroup, Button, Label, Input, Alert, ListGroup, ListGroupItem } from 'reactstrap';
import { ContentAbout0, ContentAbout1, ContentAbout2, ContentAbout3, ContentAbout4 } from '../Blocks/_ContentBlocks';
import { TextHeader, TextTitle } from '../../../Controls/Digital/TextHeaders';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faSave, faSearch, faTrash } from '@fortawesome/free-solid-svg-icons';
import DataAPI from '../Shared/DataAPI';
import TShirt from './../Resources/Images/TShirt.jpg';


export const RecordSubmission = (props) => {

    const [blockName, setBlockName] = useState("");

    const [comp, setComp] = useState("");

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [date, setDate] = useState("");
    const [location, setLocation] = useState("");
    const [country, setCountry] = useState("");
    const [points, setPoints] = useState("");
    const [weight, setWeight] = useState("");
    const [length, seLength] = useState("");
    const [year, setYear] = useState("2026");

    const [actionSaved, setActionSaved] = useState(false);

    //const [selectedOption, setSelectedOption] = useState("");
    //const [headlandName, setHeadlandName] = useState("");
    //const [headlandNotSelelected, setHeadlandNotSelelected] = useState(false);

    useEffect(() => {
    },[]);

    let onCompChange = function (item, event) {
        setComp(item.target.value);
        Common.trace(item.target.value);
    };

    let onFirstNameChange = function (item, event) {
        setFirstName(item.target.value);
    };
    let onLastNameChange = function (item, event) {
        setLastName(item.target.value);
    };
    let onEmailChange = function (item, event) {
        setEmail(item.target.value);
    };
    let onDateChange = function (item, event) {
        setDate(item.target.value);
    };
    let onLocationChange = function (item, event) {
        setLocation(item.target.value);
    };
    let onCountryChange = function (item, event) {
        setCountry(item.target.value);
    };
    let onPointsChange = function (item, event) {
        setPoints(item.target.value);
    };
    let onWeightChange = function (item, event) {
        setWeight(item.target.value);
    };
    let onLengthChange = function (item, event) {
        seLength(item.target.value);
    };

    let save = function () { };
    let reset = function () { };

    //let signOn = function () {
    //    setHeadlandNotSelelected(false);
    //    if (headlandName == '') {
    //        setHeadlandNotSelelected(true);
    //    } else {
    //        let fullHeadland = headlandName;
    //        DataAPI.signOn({ diverId: diver.id, divingLocation: fullHeadland }, actionCallBack);
    //    }
    //};

    let actionCallBack = function (data, callbackData) {
        setActionSaved(true);
    }

    let actionCallbackError = function (data, callbackData) {
        setActionSaved(true);
    }

    return (
        <Block name="submissions" isAlt={false}>
            <TextHeader 
                text="Sanc Souci Dolphins Competition Submissions"
            />
            <TextTitle
                text="Submit your catch!!! 3 awesome all year round comps for your to shine"
            />
            <TextTitle
                text="Read and comply with the rules for each of the competitions."
            />
            <TextTitle
                text={<a href="/RecordsLeaderBoard">Check the Results!!!!</a>}
            />
            <Row>
                <Col lg="4">
                    <SubmissionCategory
                        name="Pucko Challenge"
                        description="Largest pelagic"
                        location="Anywhere in the world"
                        hasPoints={false}
                    />
                </Col>
                <Col lg="4">
                    <SubmissionCategory
                        name="Club Species"
                        description="Biggest fish for the selected Club Species"
                        location="NSW only"
                        hasPoints={false}
                    />
                </Col>
                <Col lg="4">
                    <SubmissionCategory
                        name="Official Comps"
                        description="Track points from official Competitions"
                        location="NSW & QLD official competitions"
                        hasPoints={true}
                     />
                </Col>
            </Row>

            <Alert color="info">
                <Row>
                    <Col lg={{ size:4, offset:4}} align="center">
                        <FormGroup>

                            <Label for="competition">
                                Make your selection
                            </Label>
                            <Input id="competition" name="competition" type="select"
                                value={comp}
                                onChange={onCompChange}>
                                <option>Select Competition Type</option>

                                <option>Pucko Challenge</option>
                                <option>Club Species</option>
                                <option>Record Comp Points</option>
                            </Input>

                        </FormGroup>
                    </Col>
                </Row>

            </Alert>

            <Alert color="info">

                <Row>

                    <Col lg="6">

                        <FormGroup>
                            <Input type="text" value={firstName} onChange={onFirstNameChange} placeholder="First Name" />
                        </FormGroup>

                        <FormGroup>
                            <Input type="text" value={lastName} onChange={onLastNameChange} placeholder="Last Name" />
                        </FormGroup>

                        <FormGroup>
                            <Input type="text" value={email} onChange={onEmailChange} placeholder="Email Address" />
                        </FormGroup>

                    </Col>

                    <Col lg="6">

                        {comp == "Club Species" && (
                            <Fragment>

                                <FormGroup>
                                    <Input id="fishTypeSpecies" name="fishTypeSpecies" type="select">
                                        <option value="Select">Fish Species</option>

                                        <option value="Pucko">Bonito</option>
                                        <option value="Pucko">Bream</option>
                                        <option value="Pucko">Cray</option>
                                        <option value="Pucko">Dolphin Fish (Mahi Mahi)</option>
                                        <option value="Points">Drummer (Black)</option>
                                        <option value="Species">Morwong (Red)</option>
                                        <option value="Points">Morwong (Blue)</option>
                                        <option value="Points">Mulloway</option>
                                        <option value="Points">Red Rocky (Cod Red Rock)</option>
                                        <option value="Points">Kingfish</option>
                                        <option value="Points">Mackarell (any)</option>
                                        <option value="Points">Wahoo</option>
                                        <option value="Points">Salmon</option>
                                        <option value="Points">Snapper</option>
                                    </Input>
                                </FormGroup>
                            </Fragment>
                        )}

                        {comp == "Pucko Challenge" && (
                            <Fragment>
                                <FormGroup>
                                    <Input id="fishTypePelagics" name="fishTypePelagics" type="select">
                                        <option>Pelagic Fish</option>

                                        <option>Cobia</option>
                                        <option>Kingfish</option>
                                        <option>Mulloway</option>
                                        <option>Mackarell (Spanish)</option>
                                        <option>Mackarell (Grey)</option>
                                        <option>Mackarell (Grey)</option>
                                        <option>Marlin</option>
                                        <option>Sailfish</option>
                                        <option>Swordfish</option>
                                        <option>Tuna (dogtooth)</option>
                                        <option>Tuna (yellow-fin)</option>
                                        <option>Tuna (blue-fin)</option>
                                        <option>Tuna (long-fin)</option>
                                    </Input>
                                </FormGroup>
                            </Fragment>
                        )}

                        {((comp == "Pucko Challenge") || (comp == "Club Species")) && (
                            <Fragment>
                                <FormGroup>
                                    <Input type="text" value={date} onChange={onDateChange} placeholder="When / Date" />
                                </FormGroup>

                                <FormGroup>
                                    <Input type="text" value={location} onChange={onLocationChange} placeholder="location (headland / Zone)" />
                                </FormGroup>

                                <FormGroup>
                                    <Input type="text" value={country} onChange={onCountryChange} placeholder="location (Country)" />
                                </FormGroup>

                                <FormGroup>
                                    <Input type="text" value={weight} onChange={onWeightChange} placeholder="weight in grams (e.g. 15250 for 15 kg and 250 grms)" />
                                </FormGroup>

                                <FormGroup>
                                    <Input type="text" value={length} onChange={onLengthChange} placeholder="length in cm (e.g. 125)" />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="fishWeightFile">Upload Fish Weight Photo</Label>
                                    <Input id="fishWeightFile" type="file" value={points} onChange={onPointsChange} placeholder="Upload Fish Weight Photo" />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="diverAndFishFile">Upload Diver & Fish Photo</Label>
                                    <Input id="diverAndFishFile" type="file" value={points} onChange={onPointsChange} placeholder="Upload Diver & Fish Photo" />
                                </FormGroup>
                            </Fragment>
                        )}

                        {comp == "Record Comp Points" && (
                            <Fragment>
                                <FormGroup>
                                    <Input id="competitionName" name="competitionName" type="select">
                                        <option>Select Competition</option>

                                        <option>Alliman - January</option>
                                        <option>Alliman - Febrary</option>
                                        <option>Alliman - March</option>
                                        <option>Alliman - April</option>
                                        <option>Alliman - May</option>
                                        <option>Alliman - June</option>
                                        <option>Alliman - July</option>
                                        <option>Alliman - August</option>
                                        <option>Alliman - September</option>
                                        <option>Alliman - October</option>
                                        <option>Alliman - November</option>
                                        <option>Alliman - December</option>

                                        <option>Southern Zone - Huskinsson</option>
                                        <option>Southern Zone - Botany Bay</option>
                                        <option>Southern Zone - Port Kembla</option>
                                        <option>Southern Zone - Kiama</option>
                                        <option>Southern Zone - Bendalong</option>
                                        <option>Southern Zone - Currarong</option>

                                        <option>South Coast Championship - Ulladulla</option>
                                        <option>South Coast Championship - Shell Harbour</option>
                                        <option>Far South Coast Championship - Narooma</option>
                                        <option>Pacific Coast Championship - Port Stephens</option>

                                        <option>Blue Water Classic</option>
                                        <option>Eden Spearfishing Challenge</option>

                                        <option>Canada Cup</option>
                                        <option>Cloughy Challenge</option>

                                    </Input>
                                </FormGroup>

                                <FormGroup>
                                    <Input id="pointsInComp" type="text" value={points} onChange={onPointsChange} placeholder="Total Points in Competition" />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="scoreSheetFile">Upload Scoresheet</Label>
                                    <Input id="scoreSheetFile" type="file" value={points} onChange={onPointsChange} placeholder="Upload Score Sheet" />
                                </FormGroup>

                            </Fragment>
                        )}


                    </Col>

                </Row>

            </Alert>

            <Alert color="warning">
                <Row>
                    <Col lg="12" align="right">

                        <FormGroup>

                            <Button color="danger" onClick={reset}>
                                <FontAwesomeIcon icon={faTrash} /> Reset
                            </Button>
                            &nbsp;
                            <Button color="primary" onClick={save}>
                                <FontAwesomeIcon icon={faSave} /> Submit
                            </Button>

                        </FormGroup>

                    </Col>
                </Row>
            </Alert>

           
        </Block>
    );
}

export const SubmissionCategory = (props) => {

    return (
        <Block name="submissions" isAlt={false}>
            <TextHeader
                text={<Alert color="info">{props.name}</Alert>}
            />
            <TextTitle
                text={<a href="#" target="_blank"><b>{props.description}</b></a>}
            />
            <Row>
                <Col>
                    <ListGroup>
                        <ListGroupItem active>
                            <b>{props.location}</b>
                        </ListGroupItem>
                        {!props.hasPoints && (
                            <Fragment>
                                <ListGroupItem>Can make multiple submissions</ListGroupItem>
                                <ListGroupItem>Catch needs to be un-assisted</ListGroupItem>
                                <ListGroupItem>Attach a photo that clearly shows the fish weight on the scale</ListGroupItem>
                                <ListGroupItem>Attach a photo of yourself with the fish</ListGroupItem>
                            </Fragment>
                        )}
                        {props.hasPoints && (
                            <Fragment>
                                <ListGroupItem>Attach a photo of the competition sheet results</ListGroupItem>
                            </Fragment>
                        )}
                    </ListGroup>

                </Col>
                
            </Row>
        </Block>
    );
}

